import { store, getContext } from '@wordpress/interactivity';


store( 'rudr', {
	actions: {
		toggle: () => {
			const context = getContext()
			context.isOpen = ! context.isOpen;
			document.body.classList.toggle('billed-monthly');
		},
	},
	callbacks: {
		logIsOpen: () => {
			const { isOpen } = getContext();
		},
	},
} )